module.exports = __webpack_public_path__ + "img/Display- Control Terminal.fb042ec.jpg";